import scrollMonitor from 'scrollmonitor';
import {
  hasClass,
  addClass,
  removeClass,
} from '../utilities/dom';
import { getBreakpoint } from '../utilities/breakpoints';

export default class {
  constructor({
    handle,
    container,
    sidebar,
    header,
    connectHandle,
  }) {
    // Elements and class variables
    const sidebarElement = document.querySelector(sidebar);
    const headerElement = document.querySelector(header);
    const connectSection = document.querySelector(connectHandle);
    const articleContent = document.querySelector('.content__section');
    const articleImages = articleContent.querySelectorAll('.section__image');

    // Scroll watchers for main container and connect section
    const headerWatcher = scrollMonitor.create(headerElement);
    const connectWatcher = scrollMonitor.create(connectSection);

    // Function to listen for when main container reaches top of viewport, make sidebar sticky
    headerWatcher.enterViewport(() => {
      if (hasClass(sidebarElement, 'is--sticky')) {
        if (getBreakpoint() != 'sm') {
          removeClass(sidebarElement, 'is--sticky');
        }
      }
    });
    headerWatcher.exitViewport(() => {
      if (!hasClass(sidebarElement, 'is--sticky')) {
        if (getBreakpoint() != 'sm') {
          addClass(sidebarElement, 'is--sticky');
        }
      }
    });

    // Function to listen for when connect container reaches bottom of viewport, make sidebar absolute to bottom
    connectWatcher.enterViewport(() => {
      if (!hasClass(sidebarElement, 'is--fixed-bottom')) {
        if (getBreakpoint() != 'sm') {
          addClass(sidebarElement, 'is--fixed-bottom');
        }
      }
    });
    connectWatcher.exitViewport(() => {
      if (hasClass(sidebarElement, 'is--fixed-bottom')) {
        if (getBreakpoint() != 'sm') {
          removeClass(sidebarElement, 'is--fixed-bottom');
        }
      }
    });

    // Function to size inline image captions to the width of sibling image
    function sizeCaptions(image, caption) {
      const imageWidth = image.offsetWidth;
      caption.style.width = `${imageWidth}px`;
    }

    if (articleImages) {
      Array.from(articleImages).forEach(articleImage => {
        const imageCaption = articleImage.nextElementSibling;
        if (imageCaption) {
          // Should probably convert this to a ES6 Promise
          setTimeout(() => {
            sizeCaptions(articleImage, imageCaption);
          }, 500);
        }
        window.addEventListener('resize', () => {
          if (imageCaption) {
            sizeCaptions(articleImage, imageCaption);
          }
        });
      });
    }
  }
}
